/* eslint-disable no-restricted-syntax */
export function converterObjetoParaString(objeto: {
  [key: string]: any;
}): string {
  const chaves = Object.keys(objeto);
  const resultado: string[] = [];

  for (const chave of chaves) {
    const valor = objeto[chave];

    if (valor !== undefined && valor !== null && valor !== "") {
      if (Array.isArray(valor)) {
        for (const item of valor) {
          if (item !== undefined && item !== null && item !== "") {
            if (typeof item === "object" && item !== null) {
              if ("value" in item) {
                resultado.push(`${chave}=${encodeURIComponent(item.value)}`);
              } else {
                resultado.push(
                  `${chave}=${encodeURIComponent(JSON.stringify(item))}`
                );
              }
            } else {
              resultado.push(`${chave}=${encodeURIComponent(item)}`);
            }
          }
        }
      } else if (typeof valor === "object" && valor !== null) {
        if ("value" in valor) {
          resultado.push(`${chave}=${encodeURIComponent(valor.value)}`);
        } else {
          resultado.push(
            `${chave}=${encodeURIComponent(JSON.stringify(valor))}`
          );
        }
      } else {
        resultado.push(`${chave}=${encodeURIComponent(valor)}`);
      }
    }
  }

  return resultado.length > 0 ? `?${resultado.join("&")}` : "";
}
